import {Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { User } from '../../gen/model/user';
import { Logger } from '../../util/logger';
import { StandaloneComponent } from '../standalone.component';
import {CountriesService} from '../countries-service';
import {Observable, Subscription} from 'rxjs';
import {AppComponent} from '../app.component';
import {TranslateService} from '@ngx-translate/core';
import {AppConstants} from '../AppConstants';
import {ConfigurationService} from '../configuration-service';
import {SsoUIField} from '../../ssoui-configuration';
import {AppStateService, AuthenticationState} from '../app-state.service';
const cloneDeep = require('lodash.clonedeep');


@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ViewProfileComponent extends StandaloneComponent implements OnInit {

  personalFields: SsoUIField[];
  contactFields: SsoUIField[];
  loginFields: SsoUIField[];
  hasEditableFields: boolean;

  profile: User;
  hasDelegatedAuthentication = false;
  private navigationEndSubscription: Subscription;
  constructor(
    protected appStateService: AppStateService,
    route: ActivatedRoute,
    router: Router,
    protected countries: CountriesService,
    protected logger: Logger,
    protected translate: TranslateService,
    hostElement: ElementRef,
    configuration: ConfigurationService) {
  super(route, router, hostElement, configuration);
    this.focusSelectorPrefix = '.card-body';
    this.personalFields = cloneDeep(this.configuration.getProperties().profilePersonalFields);
    this.contactFields = cloneDeep(this.configuration.getProperties().profileContactFields);
    this.loginFields = cloneDeep(this.configuration.getProperties().profileLoginFields);
  }
  onProfileLoaded(user: User) {
    this.profile = user;
  }
  ngOnInit() {
    super.init();
    const authState: AuthenticationState = this.appStateService.getAppState().getAuthenticationState();
    if (authState &&
        authState.getExistingAuthentications() &&
        authState.getExistingAuthentications().length) {
        if (!authState.getExistingAuthentications().find((val) => val.authenticationMethod === AppConstants.AC_AM_PASSWORD)) {
          // hide change password when there is no password
          this.loginFields = this.loginFields.filter((val) => val.key !== 'password');
        }
        if (authState.getExistingAuthentications().find((val) => val.authenticationMethod === AppConstants.AC_AM_DELEGATED)) {
          this.hasDelegatedAuthentication = true;
          // hide totp and make all fields readonly when there is delegated auth
          this.loginFields = this.loginFields.filter((val) => val.key !== 'totp').map((v) => ({ ...v, readonly: true }));
          this.personalFields = this.personalFields.map((v) => ({ ...v, readonly: true }));
          this.contactFields = this.contactFields.map((v) => ({ ...v, readonly: true }));
        }
    } else {
      throw new Error('Not authorized');
    }
    if (this.personalFields.filter((v) => !v.readonly).length > 0 ||
      this.contactFields.filter((v) => !v.readonly).length > 0 ||
      this.loginFields.filter((v) => !v.readonly).length > 0) {
      this.hasEditableFields = true;
    } else {
      this.hasEditableFields = false;
    }
    this.onProfileLoaded(this.appStateService.getAppState().getAuthenticationState().getProfile());

    this.navigationEndSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        StandaloneComponent.setFocusToElemOrChildControl(this.hostElement, this.focusSelectorPrefix);
      }
    });
  }
  signOut() {
    this.router.navigate([AppConstants.PATH_LOGOUT], {
      relativeTo: this.route,
    });
  }

  resolveDisplayName(): string|any {
    // we should never be here with a partial session
    return AppComponent.resolveUserName(this.profile, this.translate, this.configuration);
  }

  resolveCountryName(code: string): Observable<string> {
    return this.countries.getCountryName(code);
  }

  includes(list: SsoUIField[], value: string): boolean {
    return list.findIndex((val) => val.key === value) >= 0;
  }
  /**
   * Adds &#x200b; (wordbreak) char for each non alphanumeric character
   */
  addWordBreaks(val: string): string {
    return val ? val.replace(/(\W)/g, '<wbr />$1') : val;
  }

  public resolveWindowTitlePart(): Observable<string|undefined> {
    return this.translate.get('view-profile.window-title');
  }
}
